<template>
  <div class="form-content">
     <div class="verification-code" v-show="showVaild">
      <van-form @submit="vaildCode">
        <div style="font-size:.30rem;margin-bottom:.5rem;font-weight:bold;">请先填写邀请码验证信息</div>
        <div class="li">
          <van-field
            v-model.trim="verificationCode"
            name="邀请码"
            label="邀请码"
            placeholder="请输入邀请码"
            :rules="[{ required: true, message: '请输入邀请码' }]"
            input-align="right"
            class="input"
            error-message-align="right"
          />
        </div>
        <div style="margin:.5rem;">
          <van-button round block type="info" native-type="submit" :disabled="verificationCode==''"
            >提交</van-button
          >
        </div>
      </van-form>
    </div>

     <div v-show="!showVaild">
        <div class="form-details">
          <div class="groupItem" v-for="(item, index) in itemList" :key="index">
            <p class="group-title"><i class="ic-title"></i>{{ item.title }}</p>
            <div class="item" v-for="(it, ind) in item.list" :key="ind">
              <div>
                <p class="item-name">{{ it.name }}</p>
                <p class="item-text" v-if="it.text != ''">{{ it.text }}</p>
              </div>
              <p class="item-val">{{ it.val }}</p>
            </div>
          </div>

          <div class="groupItem">
            <p class="group-title"><i class="ic-title"></i>特别约定</p>
            <div class="rule-detail">
              <p class="text"><span class="bold">1、医疗费：</span></p>
              <p class="text">到指定医院看门诊而发生的符合当地社保政策的费用，无免赔额，赔付比例100%。</p>
              <p class="text"><span class="bold">2、住院津贴：</span></p>
              <p class="text">因意外事故到指定医院住院治疗，即日给付，每次限90天，全年限180天。</p>
              <p class="text"><span class="bold">3、在工作时间、工作场所内突发疾病 48 小时内身故，认定为工伤的猝死情形，属于保险责任。</span></p>
              <p class="text"><span class="bold">4、员工发生事故必须48小时内报备，身故案件最迟不超过12小时。出险后48小时内需要拨打95511或联系单位负责人进行报案，以免影响案件理赔；</span></p>
              <p class="text"><span class="bold">5、本保单投保方式为记名投保，若有人员变更被保险人应及时通知保险人做相应批改，</span>投保时需列明工种。*若出险时与投保上传工种类别不符，保险公司不承担任何保险责任。工种类别参考承保人《职业类别表2022版》所列工种类别。</p>
              <p class="text"><span class="bold">6、指定医院指二级及二级以上公立医院，如急诊可不限医院。</span></p>
              <p class="text"><span class="bold">7、交通事故需提供交通事故责任认定书，申请医疗费需要提供第三方赔付明细。</span></p>
              <p class="text"><span class="bold">8、本保单不承保因从事高空作业（高于基准面2米以上）导致的意外事故。</span></p>
              <p class="text"><span class="bold">9、伤残等级：</span></p>
              <p class="text">伤残赔偿比例扩展为十级10%，九级20%，八级30%，七级40%，六级50%，五级60%，四级70%，三级80%，二级90%，一级100%</p>
              <p class="text"><span class="bold">10、伤残赔偿标准：工伤事故及非工伤事故导致的伤残，按《劳动能力鉴定职工工伤与职业病致残等级》（GB/T 16180-2014）评残。伤残等级对应的保额为伤残金赔偿的限额；</span></p>
            </div>
          </div>

          <div class="rule-content">
            <p class="rule-li" @click="goDetail(1)">保险（B款）条款</p>
          </div>
        </div>
        <div class="button" v-if="showWxBtn">
          <wx-open-launch-weapp
            id="launch-btn"
            @error="handleError"
            @launch="handleLaunch"
            username="gh_543cbe990f14"
            path="/pages/start/index"
            style="width:100%;height:1rem;"
          >
            <template>
              <script type="text/wxtag-template">
                <style>.my-btn{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    width: 100%;
                    height: 100%;
                    transform: translate(-50%, -50%);
                    background: #3C82FE;
                    outline: none;
                    border-radius: 0.42rem;
                    border: none;
                    color:#fff;
                    }
                </style>
                <div>
                  <button class="my-btn">我要投保</button>
                </div>
              </script>
            </template>
          </wx-open-launch-weapp>
        </div>
     </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { Toast } from "vant";
import loading from "../components/loading";
import moblieRem from "../utils/mobile-rem";
export default {
  components: {
    loading
  },
  data() {
    return {
      btnDisable: true,
      itemList: [
        {
          title: "团意险保险",
          list: [
            {
              name: "工作期间发生意外事故导致的身故",
              // text: "",
              val: "50万元"
            },
            {
                name: "非工作期间发生意外事故导致的身故",
                // text: "",
                val: "20万元"
              },
              {
                name: "工作期间发生意外事故导致的伤残",
                // text: "",
                val: "50万元"
              },
            {
                name: "非工作期间发生意外事故导致的伤残",
                // text: "",
                val: "20万元"
              },
              {
                name: "工作期间发生的医疗费用责任限额",
                // text: "",
                val: "5万元"
              },
            {
              name: "非工作期间发生医疗费用责任限额",
              // text: "",
              val: "2万元"
            },
            {
              name: "工作期间猝死",
              // text: "",
              val: "20万元"
            },
            {
              name: "意外住院津贴",
              // text: "",
              val: "100元/天"
            }
          ]
        }
      ],
      tdList: [
        { name: "一级伤残", val: "100%" },
        { name: "二级伤残", val: "90%" },
        { name: "三级伤残", val: "80%" },
        { name: "四级伤残", val: "70%" },
        { name: "五级伤残", val: "60%" },
        { name: "六级伤残", val: "50%" },
        { name: "七级伤残", val: "40%" },
        { name: "八级伤残", val: "30%" },
        { name: "九级伤残", val: "20%" },
        { name: "十级伤残", val: "10%" }
      ],
      showWxBtn:false,
      verificationCode: '',
      showVaild: true
    };
  },
  computed: {},
  mixins: [moblieRem],
  created() {
    document.title = "商保方案";
    this.getTK(); // 获取token
  },
  mounted(){
    this.getConfig();
    document.addEventListener('WeixinOpenTagsError', function (e) {
      console.error(e.detail.errMsg); // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开发标签，JS-SDK其他功能不受影响
    })
  },
  methods: {
    handleError(e) {
      console.log(e);
    },
    handleLaunch(e) {
      console.log(e);
    },
    getConfig() {
      var self = this
      this.$http({
        url:
          "/api/jmlH5Service/h5ToMiniProgram?url=" +
          location.href.split("#")[0],
        method: "post",
        data: {
          url: location.href.split("#")[0]
        }
      }).then(({ data }) => {
        var data1 = JSON.parse(data.data);
        console.log(data1);
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
          appId: data1.appId, // 必填，公众号的唯一标识
          timestamp: data1.timestamp, // 必填，生成签名的时间戳
          nonceStr: data1.noncestr, // 必填，生成签名的随机串
          signature: data1.signature, // 必填，签名
          jsApiList: ['onMenuShareTimeline'], // 必填，需要使用的JS接口列表
          openTagList: ["wx-open-launch-weapp"] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
        });
        wx.ready(function(res) {
          self.btnDisable = false
          setTimeout(() => {
            self.showWxBtn = true
          }, 500);
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
        });
        wx.error(function(res) {
          Toast('微信接口初始化错误，请稍后再试')
          self.btnDisable = false
					// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
				});
      }).catch(()=>{
        self.btnDisable = false
      });
    },

    goDetail(type){
      if(type==1){
        this.$router.push("/commercialProjectA");
      }else{
        this.$router.push("/commercialProjectAdd");
      }
    },

    //  校验邀请码
    vaildCode() {
      let that = this;
      this.$http({
        url: "api/jmlH5Service/verificationInvitationCode",
        method: "post",
        data: {
          inviteCode: this.verificationCode.trim()
        }
      }).then(({ data }) => {
        if(data.code == 200){
          Toast('验证成功')
          setTimeout(()=>{
            that.showVaild = false
          },1000)
        }
      }).catch(()=>{
        // Toast('验证失败')
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/css/addForm.less";
@import "../assets/css/commercialProject.less";
</style>
